// extracted by mini-css-extract-plugin
export default {"cont":"FormNpde_cont__Lo4JO","details":"FormNpde_details__r6GSq","placeholder":"FormNpde_placeholder__TQ-V3"};